<div class="brands">
  <h2>{{ brandSelected.title }}</h2>
  <p>{{ brandSelected.description }}</p>
  <app-main-button class="button" (click)="showSite(brandSelected.btnLink)">{{ brandSelected.btnTxt }}</app-main-button>
  <div class="banner-container">
    <img [src]="brandSelected.bannerImg" />
  </div>
</div>
